import { Mydocs } from "./pages/Mydocs";
import { BrowserRouter as Router } from "react-router-dom";
function App() {
  return (
    <Router>
      <Mydocs />
    </Router>
  );
}

export default App;
